import NavigableValidator from "./navigableValidator";
import {INavigableValidatableModel} from "~/interfaces/navigableValidationInterfaces";
import {ErrorType} from "~/enums/ErrorType";
import ValidationError, {ValidationErrorLevel} from "~/models/validationError";
import Form from "../../../formability/form_builder/models/form";
import FormElement from "../../../formability/form_builder/models/formElements/formElement";
import {IndexType, IndexTypeName} from "~/enums/formElementIndexType";

type ModelContainer = (Form & INavigableValidatableModel<Form>)

export default class FormElementIndexCapValidator extends NavigableValidator<ModelContainer> {
  INDEX_LIMIT: Record<IndexType, number> = {
    [IndexType.Keyword]: 60,
    [IndexType.Double]: 20,
    [IndexType.Date]: 20,
  }
  defaultType = ErrorType.indexCap;
  indexType: IndexType
  constructor(options, indexType?: IndexType) {
    super(options);
    this.indexType = indexType
  }
  protected _validate(model: ModelContainer): void {
    const numOfIndexedElements = model.indexedElements.filter(element => FormElement.getElementIndexType(element) === this.indexType).length

    if (numOfIndexedElements > this.INDEX_LIMIT[this.indexType]){
      this.errors.push(this.buildValidationError(model, this.indexType));
    }
  }

  buildValidationError(model: Form, type: IndexType = IndexType.Keyword) {
    return new ValidationError({
      displayName: `There are more than ${this.INDEX_LIMIT[type]} ${IndexTypeName[type]} type Indexed fields. Please reduce.`,
      type: this.defaultType,
      section: this.section,
      level: ValidationErrorLevel.Error,
      errorNavOpts: model.validation.errorNavOpts(this, this.field, model),
    });
  }
}